import { createContext, FC, useState } from 'react';

export type Data = {
  id?: string,
  title: string,
  description: string,
  image?: File,
  group?: number,
  active: boolean
  is_image: boolean
}
export interface DataContext {
  formData: Data,
  handleChangeFormData: (data: Partial<Data>) => void,
  handleUpdateFormData: (data: Partial<Data>) => void,
}

const initialData: Data = {
  id: '',
  title: '',
  description: '',
  image: undefined,
  group: 0,
  active: true,
  is_image: true,
}

export const Context = createContext<DataContext>({
  formData: initialData,
  handleChangeFormData: (data: Partial<Data>) => { },
  handleUpdateFormData: (data: Partial<Data>) => { },
})

const NewFormDataProvider: FC = (props) => {
  const [formData, setFormData] = useState<Data>({
    id: '',
    title: '',
    description: '',
    image: undefined,
    group: 0,
    active: true,
    is_image: true,
  })

  const handleChangeFormData = (data: Partial<Data>) => setFormData({ ...formData, ...data })

  const handleUpdateFormData = (data: Partial<Data>) => {
    if (data && data?.id) {
      setFormData({
        ...formData,
        id: data.id,
        title: data.title || initialData.title,
        description: data.description || initialData.description,
        image: data.image || initialData.image,
        active: data.active || false,
        is_image: data.is_image || false
      })
    }
  }

  return (
    <Context.Provider value={{ formData, handleChangeFormData, handleUpdateFormData }}>
      {props.children}
    </Context.Provider>
  )
}

export default NewFormDataProvider
